import LoadingIndicator from 'components/LoadingIndicator';
import useInitialize from 'hooks/useInitialize';
import MainRouter from './MainRouter';

function App() {
    const isInit = useInitialize();

    if (!isInit) {
        return (
            <div
                style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <LoadingIndicator />
            </div>
        );
    }

    return (<MainRouter />);
    // return <LoginPage />;
}

export default App;
